import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f7bdce5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-wrap"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sorry, we were unable to find that page", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filter-wrap"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_el_button, {
    onClick: $setup.toIndexPage
  }, {
    default: _withCtx(() => [_createTextVNode(" Back to home ")]),
    _: 1
  }, 8, ["onClick"])]), _hoisted_5]);
}